import { getQuery } from 'Helpers'
import { ParamsUrlType } from 'Pages/orders'

export const getParamsFromUrl = (): ParamsUrlType => {
	const params = getQuery()
	return {
		url: window.location.href,
		source: params.source,
		utm_medium: params.utm_medium,
		utm_campaign: params.utm_campaign,
		utm_content: params.utm_content,
	}
}
